(function (upp) {
    'use strict';
    /**
     * Set the amount input with validation
     * ngModel: the amount input value
     * stock: the amount max stock, -1 if infinite
     */
    upp.directive('productAmount', ['translator',
        function (translator) {
            return {
                require: 'ngModel',
                restrict: 'E',
                replace: true,
                transclude: true,
                scope: {
                    ngModel: '=',
                    stock: '='
                },
                templateUrl: require('../templates/product-amount-directive.html'),
                link: function($scope, element) {

                    $scope.inputMaxStock = $scope.stock;
                    var $amount = element.find('.amount-input');

                    var configTooltip = function () {
                        var msg = "PRODUCTS.PRODUCT.TOOMUCHAMOUNT";
                        if (translator) {
                            msg = translator.i18n(msg);
                        }
                        $amount.tooltip({
                            title: msg,
                            placement: "top",
                            trigger: "manual"
                        });
                    };

                    // Watcher fired when the second select change
                    $scope.$watch('stock', function() {
                        $scope.ngModel = undefined;
                        setInputMaxStock();
                    });

                    /**
                     * set the max stock we can add in the amount input field
                     */
                    var setInputMaxStock = function(){
                        if ($scope.stock > 0) {
                            $scope.inputMaxStock = $scope.stock;
                        } else if ($scope.stock == -1){
                            $scope.inputMaxStock = 99999;
                        }
                    };

                    /**
                     * when the input is changed look if we are out of stock and show the tooltip
                     * TODO: why data-ng-change is not fired?
                     */
                    $scope.$watch('ngModel', function() {
                        if ($scope.ngModel && $scope.stock >= 0 && $scope.ngModel > $scope.stock) {
                            $amount.tooltip('show');
                        } else {
                            $amount.tooltip('hide');
                        }
                    });
                    configTooltip();
                }
            };
        }]);
}(upp));


// WEBPACK FOOTER //
// ./src/app/plugins/products/directives/product-amount-directive.js